import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';

interface GeneralSettingsTableProps {
  entityType: Entities;
  schema: Record<string, unknown>;
  defaultSortField?: string;
  enableLocalFiltering?: boolean;
}

export const GeneralSettingsTable = <TEntity = Record<string, unknown>,>({
  entityType,
  schema,
  defaultSortField = 'name',
  enableLocalFiltering = true,
}: GeneralSettingsTableProps) => {
  const table = useEntityDataTableV8<TEntity, Record<string, never>>({
    schema: schema as never,
    defaultSort: [
      {
        field: defaultSortField,
        direction: SortDirection.ASCENDING,
      },
    ],
    enableMultiRowSelection: false,
    enableLocalFiltering,
  });

  const { selectedEntities } = table;

  return (
    <EntityTableV8
      hideMoreButton
      entityType={entityType}
      settingsEntityType={entityType}
      table={table.table}
      selectedEntities={selectedEntities}
      fetchMore={table.fetchMore}
      pending={table.pending}
      areas={{
        left: null,
      }}
    />
  );
};
